import HttpClient from '@/util/http/HttpClient';
import { Observable } from 'rxjs';
import Resource from '@/repositories/Resource';
import { networkBoundResource } from '@/repositories/BaseCrudRepository';

export default class UserRepository {
    private readonly client: HttpClient;
    private readonly baseUrl: string;
    private readonly logoutEndpoint: string;

    public constructor(client: HttpClient, apiEndpoint: string, logoutEndpoint: string) {
        this.client = client;
        this.baseUrl = apiEndpoint;
        this.logoutEndpoint = logoutEndpoint;
    }

    public getSelf(): Observable<{ name: string } | '' | null> {
        return this.client.get('self', { baseUrl: this.baseUrl });
    }

    public logout(): Observable<Resource<{ logoutUrl: string }>> {
        const observable = this.client.post<{ logoutUrl: string }>(this.logoutEndpoint);
        return networkBoundResource(observable);
    }
}
